module.exports = __webpack_public_path__ + "img/ChenXueRan.f1612bf0.jpg";